import React from "react";
import { Button, message, Modal } from "antd";
import { ClearOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import useIsMobile from "../../hooks/useIsMobile";

export default function Footer() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const handleClearCache = () => {
    Modal.confirm({
      title: t("clear_cache_confirm_title"),
      content: t("clear_cache_confirm_message"),
      okText: t("clear_cache"),
      cancelText: t("cancel"),
      onOk: async () => {
        try {
          if ("caches" in window) {
            const cacheNames = await caches.keys();
            await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
          }

          localStorage.clear();
          sessionStorage.clear();

          message.success(t("cache_cleared"));

          setTimeout(() => {
            window.location.reload(true);
          }, 1000);
        } catch (error) {
          console.error("Error clearing cache:", error);
          message.error(t("cache_clear_error"));
        }
      },
    });
  };

  return (
    <footer
      className="footer"
      style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "16px" }}
    >
      <span>
        Powered by <span className="font-weight-semibold">Digital KISS</span>{" "}
      </span>
      {isMobile && (
        <Button
          icon={<ClearOutlined />}
          onClick={handleClearCache}
          size="small"
          type="link"
          style={{ color: "#212529" }}
        >
          {t("clear_cache")}
        </Button>
      )}
    </footer>
  );
}
